import { jsx as r, jsxs as i } from "react/jsx-runtime";
import "react";
var h = (t) => /* @__PURE__ */ i("svg", {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [
    /* @__PURE__ */ r("rect", {
      width: "100%",
      height: "100%",
      rx: 9,
      fill: "currentColor"
    }),
    /* @__PURE__ */ r("rect", {
      width: 9.70971,
      height: 1.236,
      rx: 0.618002,
      transform: "matrix(0.710574 0.703623 -0.710574 0.703623 5.98938 5.18713)",
      fill: "white"
    }),
    /* @__PURE__ */ r("rect", {
      width: 9.70971,
      height: 1.236,
      rx: 0.618002,
      transform: "matrix(-0.710574 0.703623 -0.710574 -0.703623 12.8889 5.98077)",
      fill: "white"
    })
  ]
});
export {
  h as default
};
